module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/canteen-table/canteen_table.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/canteen-table/canteen_table.png
// module id = 528
// module chunks = 0